import { Link } from 'react-router-dom';
import { Instagram, Linkedin } from 'lucide-react';

export const Footer = () => {
  return (
    <footer data-testid="main-footer" className="bg-[#1A1A1A] text-[#F2F0E9] py-16 md:py-24">
      <div className="max-w-[1800px] mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-16">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="bg-white p-2 rounded">
                <img
                  loading="lazy"
                  decoding="async"
                  src={process.env.PUBLIC_URL + '/QualityServicesLogo.svg'}
                  alt="Quality Services Logo"
                  width="40"
                  height="40"
                  className="h-10 w-auto object-contain"
                />
              </div>
            </div>
            <p className="text-[#EBE8E1] text-sm leading-relaxed">
              Premium Printing, Office Automation, and Educational Technology.
            </p>
          </div>

          <div>
            <h4 className="serif text-lg mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/products" data-testid="footer-link-products" className="text-[#EBE8E1] text-sm hover:text-white transition-colors duration-300">
                  Products
                </Link>
              </li>
              <li>
                <Link to="/services" data-testid="footer-link-services" className="text-[#EBE8E1] text-sm hover:text-white transition-colors duration-300">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/education" data-testid="footer-link-education" className="text-[#EBE8E1] text-sm hover:text-white transition-colors duration-300">
                  Education
                </Link>
              </li>
              <li>
                <Link to="/about" data-testid="footer-link-about" className="text-[#EBE8E1] text-sm hover:text-white transition-colors duration-300">
                  About Us
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="serif text-lg mb-6">Connect With Us</h4>
            <ul className="space-y-3">
              <li>
                <a 
                  href="https://www.instagram.com/quality.services.asr/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  data-testid="footer-link-instagram"
                  className="text-[#EBE8E1] text-sm hover:text-white transition-colors duration-300 flex items-center gap-2"
                >
                  <Instagram size={16} />
                  Instagram
                </a>
              </li>
              <li>
                <a 
                  href="https://www.linkedin.com/company/qualityasr" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  data-testid="footer-link-linkedin"
                  className="text-[#EBE8E1] text-sm hover:text-white transition-colors duration-300 flex items-center gap-2"
                >
                  <Linkedin size={16} />
                  LinkedIn
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="serif text-lg mb-6">Legal</h4>
            <ul className="space-y-3">
              <li>
                <a href="#" data-testid="footer-link-cookie-policy" className="text-[#EBE8E1] text-sm hover:text-white transition-colors duration-300">
                  Cookie Policy
                </a>
              </li>
              <li>
                <a href="#" data-testid="footer-link-terms" className="text-[#EBE8E1] text-sm hover:text-white transition-colors duration-300">
                  Terms & Conditions
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#595959]">
          <p className="text-center text-[#EBE8E1] text-sm">
            &copy; {new Date().getFullYear()} Quality Services. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
